import "./industry.css"
import OutlineAnchor from "../../common/Anchors/OutlineAnchor"

export default function IndustryCaseStudySection({ caseStudyInfo }) {
 return (
  <div className="case-studies-container h-fit">
   <div className="case-study-container py-lg-4 h-100" data-aos="fade-up" data-aos-duration="600" data-aos-offset="120">
    <div className="case-study-image-container">
     <img
      src={caseStudyInfo.img}
      alt="industry case study"
      className="rounded-border"
     />
    </div>

    <aside className="mt-4 mt-lg-0 h-100 rounded-border bg-secondary">
     <h2 className="h4">
      {caseStudyInfo.title}
     </h2>
     <div className="pb-3 fs-sm-sm fs-lg-md">
      {caseStudyInfo.description}
     </div>

     <div>
      {caseStudyInfo.linksTo ? <OutlineAnchor path={caseStudyInfo.linksTo} title="Get the details" external={caseStudyInfo.external} /> : <></>}
     </div>
    </aside>
   </div>
  </div>
 )
}